module.exports = __webpack_public_path__ + "img/banner.5912895b.png";